import { MapViewport } from '../../search-history/search-history.model';
import { MapSearchResult } from '../../models/map-listing.model';
import { PolygonFilter } from '../../models/polygon-filter.model';
import { AdReport, ReportSearch } from '../../models/ad-report.model';
import { RealEstateSearch } from '../../models/real-estate-search.model';
import { RealEstate, RealEstateSearchResult } from '../../models/real-estate.model';

export interface RealEstateSortState {
  active: 'createdAt' | 'price' | 'floorArea' | 'landArea' | 'yearBuilt' | null;
  direction: 'asc' | 'desc' | null;
}

export interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

export interface RealEstateState {
  hasSearched: boolean;
  historyRestored: boolean;
  searchRestoreRevision: number;
  mapViewport?: MapViewport;
  listLoading: boolean;
  mapLoading: boolean;
  listError: string | null;
  mapError: string | null;
  listDraft: RealEstateSearch | undefined;
  mapDraft: RealEstateSearch | undefined;
  mapPagination: PaginationState;
  mapSort: RealEstateSortState;
  activePolygon: PolygonFilter | null;
  polygonRevision: number;
  query: RealEstateSearch | undefined;
  mapQuery: RealEstateSearch | undefined;
  reportQuery: ReportSearch | undefined;
  propertyResults: RealEstateSearchResult | undefined;
  propertyMapResults: MapSearchResult | undefined;
  propertyReports: AdReport[] | undefined;
  topPropertyResults: RealEstateSearchResult | undefined;
  realEstate: RealEstate | undefined;
  loading: boolean;
  isSaving: boolean;
  topLoading: boolean;
  error: string | null;
  sort: RealEstateSortState;
  pagination: PaginationState;
  isRealEstateMapView: boolean;
}

export const initialSearchState: RealEstateState = {
  hasSearched: false,
  historyRestored: false,
  searchRestoreRevision: 0,
  mapViewport: undefined,
  listLoading: false, mapLoading: false, listError: null, mapError: null,
  listDraft: undefined, mapDraft: undefined,
  mapPagination: { pageIndex: 0, pageSize: 12 }, mapSort: { active: null, direction: null },
  activePolygon: null,
  polygonRevision: 0,
  query: undefined,
  mapQuery: undefined,
  reportQuery: undefined,
  propertyResults: undefined,
  propertyMapResults: undefined,
  propertyReports: undefined,
  topPropertyResults: undefined,
  realEstate: undefined,
  loading: false,
  isSaving: false,
  topLoading: false,
  error: null,
  sort: {
    active: null,
    direction: null,
  },
  pagination: {
    pageIndex: 0,
    pageSize: 12,
  },
  isRealEstateMapView: false,
};
